export default function Logo({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
      <circle cx="14" cy="14" r="13" stroke="#1f8ef1" strokeWidth="1.5"/>
      <circle cx="14" cy="14" r="7"  stroke="#1f8ef1" strokeWidth="1.5"/>
      <circle cx="14" cy="14" r="2.5" fill="#1f8ef1"/>
      <line x1="14" y1="1"  x2="14" y2="5"  stroke="#1f8ef1" strokeWidth="1.5"/>
      <line x1="14" y1="23" x2="14" y2="27" stroke="#1f8ef1" strokeWidth="1.5"/>
      <line x1="1"  y1="14" x2="5"  y2="14" stroke="#1f8ef1" strokeWidth="1.5"/>
      <line x1="23" y1="14" x2="27" y2="14" stroke="#1f8ef1" strokeWidth="1.5"/>
    </svg>
  );
}
